import React from "react";

export function PageHeader({ title, subtitle, action, testid }) {
  return (
    <div className="flex items-start justify-between gap-4 mb-6" data-testid={testid}>
      <div>
        <h1 className="text-2xl sm:text-3xl font-bold tracking-tight text-slate-900">{title}</h1>
        {subtitle && <p className="text-sm text-slate-500 mt-1">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
}

export function EmptyState({ icon: Icon, title, subtitle, testid }) {
  return (
    <div className="text-center py-16 px-4" data-testid={testid}>
      {Icon && <Icon className="h-10 w-10 mx-auto text-slate-300 mb-3" />}
      <div className="font-medium text-slate-700">{title}</div>
      {subtitle && <div className="text-sm text-slate-400 mt-1">{subtitle}</div>}
    </div>
  );
}
